import { render } from "./NavComp.vue?vue&type=template&id=38589b26&scoped=true"
import script from "./NavComp.vue?vue&type=script&lang=js"
export * from "./NavComp.vue?vue&type=script&lang=js"

import "./NavComp.vue?vue&type=style&index=0&id=38589b26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38589b26"]])

export default __exports__